import { ProjectPreviewLayout } from '@dreamstack/feature-components/src/layout/ProjectPreviewLayout'
import { BlockHighlightRealEstate } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'
import { HighlightRealEstate } from './HighlightRealEstate'

export const HighlightBlockAsCards: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockHighlightRealEstate
  }>
> = ({ block }) => {
  const realEstates = block?.entries || []
  return (
    <>
      <ProjectPreviewLayout>
        {realEstates.map((p, i) => (
          <HighlightRealEstate realEstate={p} key={i} />
        ))}
      </ProjectPreviewLayout>
    </>
  )
}
